/* eslint-disable no-restricted-globals */
import { useEffect, useState, useCallback } from "react";
import config from "config/config";

const {
  storyblok: { accessToken },
} = config;

export default function useStory(originalStory) {
  const [story, setStory] = useState(originalStory);

  const addBridge = (callback) => {
    const existingScript = document.getElementById("storyblokBridge");
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `https://app.storyblok.com/f/storyblok-latest.js?t=${accessToken}`;
      script.id = "storyblokBridge";
      document.body.appendChild(script);
      script.onload = () => {
        callback();
      };
    } else {
      callback();
    }
  };

  const initEventListeners = useCallback(() => {
    if (window.storyblok) {
      window.storyblok.init();
      window.storyblok.on(["change", "published"], () => location.reload());

      window.storyblok.on("input", (event) => {
        const {
          content: { _uid },
        } = story;

        if (event.story.content._uid === _uid) {
          const newEvent = event;
          newEvent.story.content = window.storyblok.addComments(event.story.content, event.story.id);
          setStory(newEvent.story);
        }
      });
    }
  }, [story]);

  useEffect(() => {
    if (window.location.search.includes("_storyblok")) {
      addBridge(initEventListeners);
    } else {
      setStory(originalStory);
    }
  }, [originalStory, initEventListeners]);

  return story;
}
